import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/mainpage/MainPage'
import FactoryManager from '@/components/factories/FactoryManager'
import RepGroups from '@/components/repgroups/RepGroups'
import GoogleAuth from '@/components/auth/GoogleAuth'
import {store} from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/factories',
      name: 'FactoryManager',
      component: FactoryManager
    },
    {
      path: '/reps',
      name: 'RepGroups',
      component: RepGroups
    },
    {
      path: '/auth',
      name: 'GoogleAuth',
      component: GoogleAuth
    }
  ]
  
})

router.beforeEach((to, from, next) => {
  if(!store.state.user.email){
    if(!localStorage.repuser && to.path !== '/auth'){
      next('/auth')
    } else {
      store.commit('setuser', JSON.parse(localStorage.getItem('repuser')))
      next()
    } 
  } else {
    localStorage.setItem('repuser', JSON.stringify(store.state.user))
    next()
  }
  
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js